import { logWithSentry, stanAnalytics } from '@/lib';
import { toast } from 'react-toastify';
import React from 'react';
import { StanNotification } from '@/components/core-components/StanNotification/StanNotification';
import { SentryLogOptions, User } from '@/types';

type StanNotifyOpts = {
    type: 'success' | 'error' | 'info' | 'warning';
    title: string;
    text?: string;
    duration?: number;
    // TODO: Force this to be an error if type is error and fix issues
    error?: {
        message: string;
        options?: SentryLogOptions;
    };
};

export const stanNotify = ({ title, type, text, duration = 3000, error }: StanNotifyOpts) => {
    const user: User = window.user;
    stanAnalytics(`admin-notif-${type}`, {
        meta: {
            user_id: user?.user_id,
            username: user?.username,
        },
        props: {
            title,
            type,
            text,
            duration,
        },
    });

    if (type === 'error' && error) {
        logWithSentry(error.message, error.options);
    }

    toast(
        React.createElement(StanNotification, {
            type: type,
            title: title,
            text: text,
        }),
        {
            position: 'top-center',
            autoClose: duration,
            hideProgressBar: true,
            closeButton: false,
            className: 'stan-toast-container',
            style: {
                background: 'transparent',
                boxShadow: 'none',
                padding: 0,
            },
        }
    );
};
